<template>
  <div
      class="card"
  >
    <div>
      <b-modal v-model="showExportModal" ok-title="Close" ok-only>
        <div class="text-center">
          <a v-if="exportModalFileType === 'xlsx'" :href="exportModalUrl" target="_blank"
             :download="exportModalFileName">Download File</a>
          <a v-else :href="exportModalUrl" target="_blank" :download="exportModalFileName">Download File</a>
        </div>
      </b-modal>
    </div>
    <vue-headful
        :title="title">
    </vue-headful>
    <div class="card-body">
      <FeedbackPanel></FeedbackPanel>
      <div class="card-title">
        <div class="row">
          <h5 class="col-6"><strong>Reports</strong></h5>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="card mb-3">
            <div id="reg-field" class="card-body">
              <div v-if="showFlashMessage" class="text-danger mb-2">{{this.flashMessage}}</div>
              <div class="row">
                <form id="search-form" class="input-group">
                  <b-container fluid>
                    <b-row class="my-1">
                      <b-col sm="3">
                        <label for="input-registration">Registration:</label>
                      </b-col>
                      <b-col sm="9">
                        <b-form-input v-model="registration" id="input-registration" placeholder="Registration"
                                      required></b-form-input>
                      </b-col>
                    </b-row>

                    <b-row class="my-1">
                      <b-col sm="3">
                        <label for="input-job-id">Job ID:</label>
                      </b-col>
                      <b-col sm="9">
                        <b-form-input v-model="jobId" id="input-job-id" placeholder="Job ID" required></b-form-input>
                      </b-col>
                    </b-row>

                    <b-row class="my-1">
                      <b-col sm="3">
                        <label for="input-container-name">Container Name:</label>
                      </b-col>
                      <b-col sm="9">
                        <b-form-input v-model="containerName" id="input-container-name"
                                      placeholder="Container Name"></b-form-input>
                      </b-col>
                    </b-row>

                    <b-row class="my-1">
                      <b-col sm="3">
                      </b-col>
                      <b-col sm="9">
                        <b-form-checkbox
                            id="include-arcos-records"
                            v-model="arcosRecords"
                            name="include-arcos-records"
                            value=1
                            unchecked-value=0
                        >
                          Show Arcos Items Only
                        </b-form-checkbox>
                      </b-col>
                    </b-row>
                  </b-container>

                  <div class="mt-3">
                    <button @click.prevent="exportReport('excelExport')" class="btn btn-sm btn-primary report-buttons mr-2 ml-3">Download Excel</button>
                    <button @click.prevent="exportReport('perNdc')" class="btn btn-sm btn-primary report-buttons">Download PerNDC</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import feedbackMixin from '../mixins/feedback'
import Vue from 'vue'
import VueMoment from 'vue-moment'
import moment from 'moment'

import axios from 'axios'
import VueAxios from 'vue-axios'

import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import FeedbackPanel from "../components/FeedbackPanel";
import exportFileMixin from "@/mixins/export-file";
import {mapActions, mapGetters} from "vuex";

Vue.component('vueDropzone', vue2Dropzone);

Vue.use(VueAxios, axios);

Vue.use(VueMoment, {
  moment,
});

export default {
  name: "Reports",
  mixins: [feedbackMixin],
  components: {FeedbackPanel},
  computed: {
    ...mapGetters({
      getErrors: 'get_errors',
      nextRoute: 'get_next_route'
    }),
    title: function () {
      return 'Download reports'
    }
  },
  methods: {
    ...mapActions({
      pushError: 'push_error',
      setNextRoute: 'set_next_route',
      clearErrors: 'clear_errors',
    }),
    exportReport: function (restEntity) {
      this.flashMessage = ''
      this.showFlashMessage = false

      if (this.registration === '' || this.jobId === '') {
        this.flashMessage = "Registration and Job ID are both required"
        this.showFlashMessage = true
        console.log("Empty registration and jobId")
        return;
      }

      let payload = {}
      // Rest entity should be excelExport or perNdc
      payload.registration = this.registration;
      payload.jobId = this.jobId;
      payload.containerName = this.containerName;
      payload.showArcos = this.arcosRecords;
      payload.reportType = restEntity;

      let fileType;

      if (restEntity === 'excelExport') {
        fileType = 'xlsx'
      } else {
        fileType = 'pdf'
      }

      this.axios.post(`/3ds/api/exportReport`, payload, {
        headers: {
          'Authorization': 'Bearer ' + this.token
        },
      })
          .then(value => {
            console.log('File export succeeded')
            console.log(JSON.stringify(value))
            this.showExportModal = true
            this.exportModalUrl = value.data.data[0].fieldData.Container
            this.exportModalFileType = fileType
            this.exportModalFileName = "export." + fileType
          })
          .catch(reason => {
            console.error('File export failed')
            console.error('reason', reason.response.data )
            try {
              const scriptResult = JSON.parse(reason.response.data.scriptResult);
              this.flashMessage = scriptResult.message
              this.showFlashMessage = true
            } catch (e) {
              this.flashMessage = "The report could not be generated at the moment."
              this.showFlashMessage = true
            }
          })
      // .finally(() => this.show = false)

    }
  },
  data() {
    return {
      restEntity: 'report',
      registration: '',
      jobId: '',
      arcosRecords: 0,
      containerName: '',
      showExportModal: false,
      exportModalUrl: null,
      exportModalFileName: null,
      exportModalFileType: null,
      showFlashMessage: false,
      flashMessage: '',
    }
  }
}
</script>

<style scoped>
.report-buttons {
  width: 140px;
  display: inline;
}
</style>